module.exports = __webpack_public_path__ + "static/media/YF62_0.1740612c.jpg";